import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';

const DialogIntegrate = (props: any) => {
  return (
    <Dialog
      open={props.openIntegrate}
      onClose={props.handleCloseDialogIntegrate}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle
        id='scroll-dialog-title'
        sx={{ p: '10px 20px' }}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography
            sx={{ fontSize: '20px', lineHeight: '24px', fontWeight: 500 }}
          >
            確認
          </Typography>
          <IconButton
            aria-label='Close'
            edge='end'
            onClick={props.handleCloseDialogIntegrate}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description' fontSize={'14px'} color={'#434154'}>
          このIDを統合してよろしいですか？
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={props.handleCloseDialogIntegrate}
        />
        <BtnGradient
          text='はい'
          handleButtonClick={props.handleAgreeIntegrate}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogIntegrate;
